export default "/images/vendor/intl-tel-input/build/flags@2x.png?9d5328fb490cddd43f6698012123404b";